<template>
  <v-card outlined rounded="lg">
    <v-alert v-if="error" type="error" class="mb-0">{{ error }}</v-alert>
    <v-card-text v-else class="d-flex flex-wrap justify-space-around px-">
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights?.totalPendingAmount | currency }}
        </h6>
        <span class="text-caption">
          {{ highlights?.totalPendingRecords | number }} pagamentos pendentes
        </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights?.amountSalesToday | currency }}
          <evolution-display
            :actual="highlights?.amountSalesToday"
            :comparison="highlights?.amountSalesYesterday"
          />
        </h6>
        <span class="text-caption">
          {{ highlights?.totalSalesToday | number }} vendas hoje
        </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights?.amountSalesThisWeek | currency }}
          <evolution-display
            :actual="highlights?.amountSalesThisWeek"
            :comparison="highlights?.amountSalesLastWeek"
          />
        </h6>
        <span class="text-caption">
          {{ highlights?.totalSalesThisWeek | number }} vendas essa semana
        </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights?.amountSalesThisMonth | currency }}
          <evolution-display
            :actual="highlights?.amountSalesThisMonth"
            :comparison="highlights?.amountSalesLastMonth"
          />
        </h6>
        <span class="text-caption">
          {{ highlights?.totalSalesThisMonth | number }} vendas esse mês
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import FINANCIAL from "@/services/admin/financial";
import EvolutionDisplay from "../../global/EvolutionDisplay.vue";

export default {
  components: { EvolutionDisplay },
  data() {
    return {
      highlights: null,
      loading: false,
      error: null,
    };
  },
  methods: {
    async getHighlights() {
      this.loading = true;
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await FINANCIAL.getPaymentHighlight({ timezone });
        this.highlights = response;
      } catch (error) {
        this.error = error.message || "Erro ao buscar dados";
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getHighlights();
  },
};
</script>

<style></style>
